import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import classnames from 'classnames/bind';

import { AdminSingleDocument } from '@SERVICES';

import useOrderChaptersDrawer from '@HOOKS/store/drawers/useOrderChaptersDrawer';
import useDocumentPermissions from '@HOOKS/useDocumentPermissions';

import StickyHeader from '@COMPONENTS/HEADERS/StickyHeader';
import ChangeOrderButton from '@COMPONENTS/COMMON/buttons/ChangeOrderButton';

import styles from './ChaptersStickyHeader.module.scss';

const cx: CX = classnames.bind(styles);

function ChaptersStickyHeader(props: Props) {
    const { documentData, top } = props;

    const {
        canEditDocument,
    } = useDocumentPermissions({
        documentOwnerId: documentData.data.owner.id,
        permissions: documentData.meta.permissions,
    });

    const {
        actions: orderChaptersDrawerActions,
    } = useOrderChaptersDrawer(() => true);



    return (
        <StickyHeader
            top={top}
        >
            <div className={cx('chapters-sticky-header', 'container')}>
                <div className={cx('title')}>
                    Chapters
                </div>
                <div className={cx('buttons-wrapper')}>
                    <div className={cx('order-chapters-button')}>
                        <ChangeOrderButton
                            onClick={() => {
                                orderChaptersDrawerActions.open({
                                    documentId: documentData.data.id,
                                    chapters: documentData.data.chapters,
                                    canEditDocument,
                                });
                            }}
                        />
                    </div>


                </div>
            </div>
        </StickyHeader>
    );
}

ChaptersStickyHeader.propTypes = {
    top: PropTypes.number.isRequired,
};

type Props = InferProps<typeof ChaptersStickyHeader.propTypes> & {
    documentData: AdminSingleDocument,
};

export default ChaptersStickyHeader;
